<script lang="ts">
 import McuConfig from "../app/mcu_config.svelte";
</script>

<div class="area">
    <McuConfig />
</div>

